import './notification-management.scss'
import { useCallback, useEffect, useState } from 'react';
import api from 'api';
import { NotficationManagementType } from 'types/notification-management';
import { NotificationType } from 'types';
import { toast } from 'react-toastify';

function NotificationManagement() {

    const [subscribedContent, setSubscribedContent] = useState<NotficationManagementType[]>([]);

    const getSubscribedContent = useCallback(async () => {
        const data = await api.report.getSubscribedAlerts();
        if (!data.length) {
            alert('You are not subscribed to any alerts')
        }
        setSubscribedContent(data);
    }, [])

    function getContentType(notificationType: number) {
        switch (notificationType) {
            case 1:
                return "Scheduled Report"
            case 2:
                return "Reaction List Alert"
            case 3:
                return "Contact Notification"
            default:
                return ""
        }
    }

    function getFrequency(frequency: number) {
        switch (frequency) {
            case 0:
                return "Immediate Delivery"
            case 5:
                return "Every 5 Minutes"
            case 10:
                return "Every 10 Minutes"
            case 15:
                return "Every 15 Minutes"
            case 30:
                return "Every 30 Minutes"
            case 60:
                return "Every 60 Minutes"
            case 360:
                return "Every 6 Hours"
            case 720:
                return "Every 12 Hours"
            case 1440:
                return "Every 24 Hours"
            default:
                return ""
        }
    }

    const RemoveSubscription = useCallback(async (reportId: number, reportType: number) => {
        const data = await api.report.removeSubscription(reportId, reportType);

        if (data) {
            getSubscribedContent()
        }
        else{
            alert("Error occurend removing subscription")
        }
    }, [])

    useEffect(() => {
        getSubscribedContent()
    }, [getSubscribedContent])

    return (
        <>
            {!subscribedContent ?
                <div>No Subscribed Content Found</div>
                :
                <div className="table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Frequency</th>
                                <th>Notification Type</th>
                                <th>Project Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscribedContent.map((x: NotficationManagementType, i: number) => {
                                return (
                                    <tr key={i}>
                                        <td>{x.ReportName}</td>
                                        <td>{x.FrequencyDescription ? x.FrequencyDescription : getFrequency(x.FrequencyId)}</td>
                                        <td>{getContentType(x.NotificationType)}</td>
                                        <td>{x.ProjectName}</td>
                                        <td style={{ cursor: 'pointer', textAlign: 'center' }}><i onClick={() => RemoveSubscription(x.ReportId, x.NotificationType)} style={{ color: '#A31D42', fontWeight: 'bold' }} title='Unsubscribe' className="fal fa-ban"></i></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </>
        // <div key={x.ReportId}>{x.ReportName}</div>
    )

}

export default NotificationManagement;